import { render, staticRenderFns } from "./StatistiquesView.vue?vue&type=template&id=156850d8"
import script from "./StatistiquesView.vue?vue&type=script&lang=js"
export * from "./StatistiquesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports